/**
 * Константы для проверки типов
 */
export default class PixiType
{
    public static readonly GAME_OBJ_CARD = 'GameObjCard';
    public static readonly GAME_OBJ_PILE = 'GameObjPile';

    public static readonly ZONE_HAND  = 'hand';
    public static readonly ZONE_TABLE = 'table';
}
